export const SET_ACTIVE_CHAT_THREAD = 'SET_ACTIVE_CHAT_THREAD';
